import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Card, CardActionArea, Chip, Dialog, DialogContent, DialogTitle, IconButton, MuiThemeProvider, Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import isEmpty from 'lodash.isempty';
import { useMemo, useState } from 'react';
import ReactJson from 'react-json-view';
import themes from 'themes';
import { yiq } from 'yiq';
import { fmtColor } from 'util/format';
import ZennyaTheme from 'themes/theme';
import { CategoryContentDialog } from './CategoryContenttDialog';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    height: 230,
    width: 225,
    flex: 'none',
    '&:hover': {
      boxShadow: theme.shadows[10],
    },
    cursor: 'pointer',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'flex-start',
    position: 'relative',
  },
  serviceIcon: {
    width: 160,
    flex: 0,
    height: 'auto',
    alignSelf: 'flex-end',
    objectFit: "cover",
    objectPosition: "bottom",
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 0
  },
  serviceInfo: {
    flex: 1,
    alignSelf: 'normal',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: theme.spacing(2),
    alignItems: 'flex-start',

    "&>h6": {
      paddingBottom: theme.spacing(1.5)
    },
    zIndex: 1
  },
  serviceAction: {
    flex: 0,
    width: 75,
  },
  svcIcon: {
    height: theme.spacing(1.5),
    width: 'auto',
  },
  chip: {
    boxShadow: theme.shadows[1],
    margin: theme.spacing(.25),
    ...theme.typography.button,
    fontSize: '.85em'
  },
  dialogPaper: {
    background: (props) => `linear-gradient(30deg, ${fmtColor(props?.header_start_color)} 0%, ${fmtColor(props?.header_end_color)} 100%)`
  }

}));
const ServiceCategoryCard = ({ category, onSelect = (card) => { } }) => {
  const styleProps = {
    header_start_color: category?.header_start_color,
    header_end_color: category?.header_end_color,
    header_text_color: category?.header_text_color,
  }
  const classes = useStyles(styleProps)
  
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"), {
    noSsr: true,
  });

  const trackEvent = useTrackEvent()


  const [showDialog, setShowDialog] = useState(false);

  const textColor = useMemo(
    () => {
      const colorYiq = yiq(fmtColor(category?.type?.color) ?? '#fff', { threshold: 128 })
      const color = colorYiq === '#000' ? ZennyaTheme.dark.palette.text.primary : ZennyaTheme.light.palette.text.primary
      return color
    }, [category]
  );
  return (
    <>
      <Dialog
        maxWidth="sm"
        scroll='paper'
        fullWidth
        fullScreen={isMobile}
        open={showDialog}
        onClose={() => {
          trackEvent('Create Booking Category Card - close')
          setShowDialog(false)
        }}
        classes={{
          paper: classes.dialogPaper
        }}
      >
        <CategoryContentDialog
          item={category}
          onSelect={() => {
            setShowDialog(false)
            trackEvent('Create Booking Category Card - select')
            onSelect(category)
          }}
          onClose={() => setShowDialog(false)} />
      </Dialog>
      <Card
        className={classes.root}
        style={{
          background: fmtColor(category?.type?.color),
        }}>
        <CardActionArea onClick={() => {
          trackEvent('Create Booking Category Card - open')
          setShowDialog(true)
        }} className={classes.container}>
          <img className={classes?.serviceIcon}
            src={`${category?.type?.icon_url}`}
          />
          <div className={classes?.serviceInfo}>
            <Typography
              style={{
                color: textColor
              }}
              variant='h3'>{category?.type?.label}</Typography>
            {/* <Typography
              style={{
                color: textColor,
              }}
              variant='body2'>{category?.description}</Typography> */}
            <div style={{ flex: 1, }} />
            {category?.type?.tags?.split(',')?.map((tag, i) => (
              <Chip
                size="small"
                className={classes.chip}
                style={{
                  color: category?.booking_type?.fg_color,
                  backgroundColor: category?.booking_type?.bg_color,
                }}
                label={tag}
              />
            ))}
          </div>

        </CardActionArea>
      </Card>
    </>
  )
}


export { ServiceCategoryCard };
